import { render, staticRenderFns } from "./Privacypolicy.vue?vue&type=template&id=2dab0c7a&scoped=true"
import script from "./Privacypolicy.vue?vue&type=script&lang=js"
export * from "./Privacypolicy.vue?vue&type=script&lang=js"
import style0 from "./Privacypolicy.vue?vue&type=style&index=0&id=2dab0c7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dab0c7a",
  null
  
)

export default component.exports